<template>
  <a-modal title="批量替换物料" v-model="modal.visible" :maskClosable="false" :afterClose="onAfterClose" :width="500">
    <template slot="footer">
      <a-button @click="handleCancel">
        取消
      </a-button>
      <a-button type="primary" :loading="modal.loading" @click="handleOk">
        确定
      </a-button>
    </template>
    <section>
      <a-space direction="vertical" style="width: 100%">
        <!-- <a-alert
          message="替换说明"
          type="info"
          show-icon
        >
          <p slot="description" v-html="description"></p>
        </a-alert> -->
        <a-row :gutter="16">
          <a-col :span="12">
            <a-card title="旧物料" size="small">
              <a-tooltip>
                <template v-if="sourceMaterialNo === ''" slot="title">
                  <span>至少输入2位物料编码搜索</span>
                </template>
                <lsSelectPage
                  :isAsync="true"
                  :dropdownMatchSelectWidth="false"
                  :datas="searchMaterial['source'].list"
                  searchKey="label"
                  valueKey="selectedValue"
                  :not-found-content="searchMaterial['source'].fetching ? undefined : null"
                  @onSearch="(val) => onSearchMaterial(val, 'source')"
                  @input="(val) => onSelectMaterial(val, 'source')"
                  v-model="sourceMaterialNo"
                >
                  <a-spin v-if="searchMaterial['source'].fetching" slot="notFoundContent" size="small" />
                  <template slot="select-option" slot-scope="{items}">
                    <a-select-option v-for="i in items" :key="i.selectedValue" :value="i.selectedValue" :title="`${i.label}`">
                      {{ i.label }}
                    </a-select-option>
                  </template>
                </lsSelectPage>
              </a-tooltip>
            </a-card>
          </a-col>
          <a-col :span="12">
            <a-card title="新物料" size="small">
              <a-tooltip>
                <template v-if="targetMaterialNo === ''" slot="title">
                  <span>至少输入2位物料编码搜索</span>
                </template>
                <lsSelectPage
                  :isAsync="true"
                  :dropdownMatchSelectWidth="false"
                  :datas="searchMaterial['target'].list"
                  searchKey="label"
                  valueKey="selectedValue"
                  :not-found-content="searchMaterial['target'].fetching ? undefined : null"
                  @onSearch="(val) => onSearchMaterial(val, 'target')"
                  @input="(val) => onSelectMaterial(val, 'target')"
                  v-model="targetMaterialNo"
                >
                  <a-spin v-if="searchMaterial['target'].fetching" slot="notFoundContent" size="small" />
                  <template slot="select-option" slot-scope="{items}">
                    <a-select-option v-for="i in items" :key="i.selectedValue" :value="i.selectedValue" :title="`${i.label}`">
                      {{ i.label }}
                    </a-select-option>
                  </template>
                </lsSelectPage>
              </a-tooltip>
            </a-card>
          </a-col>
        </a-row>
      </a-space>
    </section>
  </a-modal>
</template>

<script>
import {
  apiGetBomNewMaterial,
  apiBatchModifyMaterial
} from "@/api/mdm/matter/manufacture-mbom.js";
import debounce from "lodash.debounce";

export default {
  name: "ReplaceMaterialModal",
  props: {
  },
  data() {
    this.onSearchMaterial = debounce(this.onSearchMaterial, 500);
    return {
      modal: {
        visible: false,
        loading: false
      },
      // 旧物料列表
      sourceMaterialList: [],
      // 选中的旧物料编码
      sourceMaterialNo: '',
      // 旧物料列表
      sourceMaterialNos: [],
      // 选中的新物料
      targetMaterial: null,
      // 选中的新物料b编码
      targetMaterialNo: '',
      selectMaterial: {
        source: null,
        target: null
      },
      // 搜索物料数据源
      searchMaterial: {
        source: {
          list: [],
          fetching: false,
          lastFetchId: 0
        },
        target: {
          list: [],
          fetching: false,
          lastFetchId: 0
        }
      },
      description: "1、待提交、待审核、已驳回状态下才能进行替换;<br>2、产品类型为【板木】时候，替换前后的的原材料物料编码需要为同一结构类型，方可执行原材料物料替换"
    }
  },
  computed: {
  },
  methods: {
    show(config) {
      const { list } = config;
      this.sourceMaterialList = list;
      this.sourceMaterialNos = [...new Set(list.map(item => item.id))].map(item => {
        return {
          id: item
        }
      });
      this.modal.visible = true;
    },
    /**
     * @description: 搜索物料编码
     */
    onSearchMaterial(value, type) {
      if (value.length > 1) {
        this.searchMaterial[type].lastFetchId += 1;
        const fetchId = this.searchMaterial[type].lastFetchId;
        this.searchMaterial[type].fetching = true;
        const params = {
          organizationCode: 'A001',
          pageSize: 50,
          pageNum: 1,
          label: value
        };
        apiGetBomNewMaterial(params).then(res => {
          if (fetchId !== this.searchMaterial[type].lastFetchId) {
            return;
          }
          this.searchMaterial[type].list = res || [];
          this.searchMaterial[type].fetching = false;
        });
      } else {
        this.searchMaterial[type].list = [];
        this.searchMaterial[type].fetching = false;
      }
    },
    /**
     * @description: 从物料下拉列表中选择后的回调操作
     * @params val:选中值
     */
    onSelectMaterial(val, type) {
      if (!val) {
        this.selectMaterial[type] = null;
        // this.targetMaterial = null;
      } else {
        this.selectMaterial[type] = this.searchMaterial[type].list.find(item => item.selectedValue === val);
      }
    },
    /**
     * @description: 点击提交替换物料操作
    */
    handleOk() {
      if (this.modal.loading) {
        return;
      }
      if (this.selectMaterial.target === null) {
        this.$message.warning('请选择一个新物料进行替换！');
        return;
      }
      this.modal.loading = true;
      const params = {
        ids: this.sourceMaterialList.map(item => item.id),
        newItemCode: this.selectMaterial.target.selectedValue,
        oldItemCode: this.selectMaterial.source.selectedValue
      }
      apiBatchModifyMaterial(params).then(res => {
        if(res?.code === 200) {
          this.$message.success(res.msg || "操作成功");
          this.modal.visible = false;
          this.$emit('refresh');
        }
      }).finally(() => {
        this.modal.loading = false;
      })
    },
    onAfterClose() {
      this.sourceMaterialNo = '';
      this.targetMaterial = null;
      this.targetMaterialNo = '';
      this.searchMaterial.source.list = [];
      this.searchMaterial.target.list = [];
    },
    handleCancel() {
      this.modal.visible = false;
    }
  }
}
</script>

<style scoped>

</style>
